// React
import React, { useRef, useState } from "react";
// React

import styles from "./VideoTag.module.css";

import { useSearchParams } from "react-router-dom";

const VideoTag = () => {
  const [searchParams] = useSearchParams();

  const [currentTime, setCurrentTime] = useState(0);
  const videoRef = useRef<any>(null);

  const handleTimeUpdate = () => {
    // Update the current time in the state
    if (!videoRef.current) return;
    setCurrentTime(videoRef.current.currentTime);
  };

  const handleSeek = (newTime: any) => {
    // Seek to the specified time
    videoRef.current.currentTime = videoRef.current.currentTime + newTime;
    // Update the current time in the state
    setCurrentTime(newTime);
  };

  return (
    <>
      <video
        className={`${styles.videoPlayer}`}
        autoPlay
        ref={videoRef}
        controls
        id="video"
        src={`https://stage-api.amoozeshmelli.com/download-video/${searchParams.get(
          "videoId"
        )}`}
        onDurationChange={(e) => {
          console.log(e);
        }}
        onSeeking={(e) => {}}
        onTimeUpdate={handleTimeUpdate}
      />
      <button
        onClick={() => {
          handleSeek(100);
        }}
        className="bg-purple-300 mt-4 rounded-lg p-3"
      >
        seek +10
      </button>
      currTime : {currentTime}
    </>
  );
};

export default VideoTag;
